import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59cba159"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-field p-col p-col-12 p-md-12 p-lg-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Chọn thời gian tìm kiếm: ", -1))
const _hoisted_5 = { class: "p-field p-col p-col-12 p-lg-12 p-md-12 p-sm-12" }
const _hoisted_6 = { class: "p-field p-col p-col-12 p-lg-12 p-md-12 p-sm-12" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Row = _resolveComponent("Row")!
  const _component_ColumnGroup = _resolveComponent("ColumnGroup")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { header: "THỐNG KÊ THEO THỜI GIAN" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_Calendar, {
              id: "date",
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
              selectionMode: "range",
              dateFormat: "dd/mm/yy",
              showButtonBar: true,
              showIcon: true,
              manualInput: false,
              monthNavigator: true,
              yearNavigator: true,
              yearRange: "2000:2100",
              onDateSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectCalendar())),
              onClearClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearCalendar()))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DataTable, {
              value: _ctx.dashboardDT,
              showGridlines: "",
              rows: 40,
              rowHover: true,
              style: {"font-size":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ColumnGroup, { type: "header" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Tên khoa",
                          rowspan: 1
                        }),
                        _createVNode(_component_Column, {
                          header: "Vào viện",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Ra viện",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Hiện có",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "CCLVT",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Loãng xương",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Điện cơ",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Nội soi",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "CS cấp 1",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Tổng Chỉ định",
                          rowspan: 1,
                          style: {"background":"#fa929b"}
                        }),
                        _createVNode(_component_Column, {
                          header: "CĐ tại Khoa",
                          rowspan: 1,
                          style: {"background":"#fa929b"}
                        }),
                        _createVNode(_component_Column, {
                          header: "CĐ tại PHCN",
                          rowspan: 1,
                          style: {"background":"#fa929b"}
                        }),
                        _createVNode(_component_Column, {
                          header: "CĐ tại CLS",
                          rowspan: 1,
                          style: {"background":"#fa929b"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Tên khoa"
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Tag, {
                      severity: "info",
                      value: slotProps.data.phongBan
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Vào viện",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.vaoVien), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Ra viện",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.raVien), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Hiện có",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Tag, {
                      severity: "success",
                      value: slotProps.data.dangDT
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "CCLVT",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.ct), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Loãng xương",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.loangXuong), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Điện cơ",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.dienCo), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Nội soi",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.noiSoi), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "CS cấp 1",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(slotProps.data.cS1), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Tổng Chỉ định",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.convertMoney(slotProps.data.tongTienChiDinh)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "CĐ tại Khoa",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.convertMoney(slotProps.data.tongTienThucHien)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "CĐ tại PHCN",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.convertMoney(slotProps.data.tongTienPHCN)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "CĐ tại CLS",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    _createTextVNode(_toDisplayString(_ctx.convertMoney(slotProps.data.tongTienCLS)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          footer: "Tổng số nội trú:",
                          colspan: 3,
                          footerStyle: "text-align:right"
                        }),
                        _createVNode(_component_Column, {
                          footer: _ctx.noiTru,
                          style: {"color":"#1C93ED"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: "Tổng số điều trị ngoại trú:",
                          colspan: 4,
                          footerStyle: "text-align:right"
                        }),
                        _createVNode(_component_Column, {
                          footer: _ctx.dieuTriNoiTru,
                          style: {"color":"green"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.convertMoney(_ctx.tongTienCD),
                          style: {"color":"red","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.convertMoney(_ctx.tongTienTH),
                          style: {"color":"red","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.convertMoney(_ctx.tongTienPHCN),
                          style: {"color":"red","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.convertMoney(_ctx.tongTienCLS),
                          style: {"color":"red","font-weight":"bold"}
                        }, null, 8, ["footer"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DataTable, {
              value: _ctx.dashboardDV,
              showGridlines: "",
              rows: 40,
              rowHover: true,
              style: {"font-size":"20px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ColumnGroup, { type: "header" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          header: "Tên khoa",
                          rowspan: 1
                        }),
                        _createVNode(_component_Column, {
                          header: "Điện châm",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Cấy chỉ",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Giác hơi",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Xoa bóp",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Xông hơi thuốc",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Tổng YHCT",
                          rowspan: 1,
                          style: {"background":"#f6fbc3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Điện xung",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Siêu âm",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Hồng ngoại",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Các DV Tập",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Xoa bóp vùng",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Oxy cao áp",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        }),
                        _createVNode(_component_Column, {
                          header: "Tổng PHCN",
                          rowspan: 1,
                          style: {"background":"#c1f9f3"}
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Tên khoa"
                }, {
                  body: _withCtx((slotProps) => [
                    _createVNode(_component_Tag, {
                      severity: "info",
                      value: slotProps.data.phongBan
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Điện châm",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(1, slotProps.data.dienCham))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.dienCham
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(slotProps.data.dienCham), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Cấy chỉ",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(2, slotProps.data.cayChi))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.cayChi
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(slotProps.data.cayChi), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Giác hơi",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(3, slotProps.data.giacHoi))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.giacHoi
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(slotProps.data.giacHoi), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Xoa bóp",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(4, slotProps.data.xoaBop))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.xoaBop
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(slotProps.data.xoaBop), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Xông hơi thuốc",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(6, slotProps.data.xongHoi))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.xongHoi
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(slotProps.data.xongHoi), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "tongYHCT",
                  header: "Tổng YHCT",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(7, slotProps.data.tongYHCT))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.tongYHCT
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createVNode(_component_Tag, {
                            severity: "warning",
                            value: slotProps.data.tongYHCT
                          }, null, 8, ["value"])
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Điện xung",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(8, slotProps.data.dienXung))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.dienXung
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(slotProps.data.dienXung), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Siêu âm",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(9, slotProps.data.sieuAm))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.sieuAm
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(slotProps.data.sieuAm), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Hồng ngoại",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(10, slotProps.data.hongNgoai))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.hongNgoai
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(slotProps.data.hongNgoai), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Các DV Tập",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(11, slotProps.data.tap))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.tap
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(slotProps.data.tap), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Xoa bóp vùng",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(12, slotProps.data.ktXoaBopVung))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.ktXoaBopVung
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(slotProps.data.ktXoaBopVung), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "",
                  header: "Oxy cao áp",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(13, slotProps.data.oxy))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.oxy
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(slotProps.data.oxy), 1))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "tongPHCN",
                  header: "Tổng PHCN",
                  style: {"font-weight":"bold"}
                }, {
                  body: _withCtx((slotProps) => [
                    (_ctx.findIndex(14, slotProps.data.tongPHCN))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createVNode(_component_Tag, {
                            severity: "danger",
                            value: slotProps.data.tongPHCN
                          }, null, 8, ["value"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
                          _createVNode(_component_Tag, {
                            severity: "success",
                            value: slotProps.data.tongPHCN
                          }, null, 8, ["value"])
                        ]))
                  ]),
                  _: 1
                }),
                _createVNode(_component_ColumnGroup, { type: "footer" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Column, {
                          footer: "Tổng số:",
                          colspan: 1,
                          footerStyle: "text-align:left"
                        }),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongDienCham,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongCayChi,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongGiacHoi,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongXoaBop,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongXongHoi,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongCongYHCT,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongDienXung,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongSieuAm,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongHongNgoai,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongTap,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongKtXoaBopVung,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongOxy,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"]),
                        _createVNode(_component_Column, {
                          footer: _ctx.tongCongPHCN,
                          style: {"color":"#0471c4","font-weight":"bold"}
                        }, null, 8, ["footer"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value"])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}